import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import { useNavigate } from "react-router-dom";

function AiAvatarProcess({ onBack }) {
    const navigate = useNavigate();

    const handleNavigation = () => {
        navigate("/dashboard/create-avatar/list");
    };

    // Automatically navigate after 6 seconds
    useEffect(() => {
        const timer = setTimeout(() => {
            handleNavigation();
        }, 6000); // 6000 milliseconds = 6 seconds

        // Cleanup function to clear the timer if the component unmounts
        return () => clearTimeout(timer);
    }, []); // Empty dependency array ensures this runs once when the component mounts

    return (
        <div style={{ padding: "20px" }}>
            <Typography variant="highlightSemibold">Image Modelling</Typography>
            <br />
            <Typography variant="supportRegular">
                Now sit back and relax. AI is processing your images, it will
                take some time. By the time you can wait or perform other tasks.
                Don’t worry we will notify you once modelling is complete.
            </Typography>
            <br />
            <br />
            <Box sx={{ width: "100%" }}>
                <LinearProgress
                    sx={{
                        marginTop: 2,
                        marginBottom: 2,
                        backgroundColor: "#e0e0e0",
                        height: 10, // Increased height of the loader
                        borderRadius: 5, // Optional: adds rounded corners
                        "& .MuiLinearProgress-bar": {
                            backgroundColor: "#16BB4D",
                        },
                    }}
                />
            </Box>

            <br />

            <Button
                variant="contained"
                sx={{ width: "35%", marginTop: "2rem", marginBottom: "2rem" }}
                onClick={handleNavigation}
            >
                Go Back to AI Avatars{" "}
            </Button>
            {/* Uncomment if you want to enable the onBack button */}
            {/* <Button
                variant="contained"
                sx={{ width: "35%", marginTop: "2rem", marginBottom: "2rem" }}
                onClick={onBack}
            >
                Go Back
            </Button> */}
        </div>
    );
}

export default AiAvatarProcess;
